/* ============================================================
   Данные нового дизайна «Федерация киберспорта СКО».
   Перенесены из дизайн-макета (new_design/Федерация киберспорта СКО.dc.html)
   ============================================================ */

// TikTok LIVE трансляций федерации — стрим турниров (MLBB и др.).
// Единый источник правды: плеер на странице «Эфир», соцлинки, тикер.
export const TIKTOK_USER = 'ya_znayu02';
export const TIKTOK_LIVE_URL = `https://www.tiktok.com/@${TIKTOK_USER}/live`;
// Официальный embed-эндпоинт LIVE — отдаётся без X-Frame-Options,
// поэтому его можно встроить в iframe (в отличие от /@user/live).
export const TIKTOK_EMBED_URL = `https://www.tiktok.com/embed/live/@${TIKTOK_USER}`;

// Флаг страны — локальные ассеты (есть все 40 стран турнира)
export const flag = (cc) => (cc ? `/assets/flags/${cc}.png` : '');

// Градиентная «обложка» из hue
export const cover = (hue, l1 = 22, l2 = 10) =>
  `linear-gradient(150deg,hsl(${hue} 55% ${l1}%),hsl(${hue} 40% ${l2}%))`;
export const coverTour = (hue) =>
  `linear-gradient(150deg,hsl(${hue} 60% 20%),hsl(${hue} 45% 9%))`;

/** Поле турнира на текущем языке: tl(t, 'title', lang), tl(t, 'date', lang)…
    Порядок фолбэка: <поле>_<lang> → <поле>_ru → <поле>. Последний шаг нужен
    для title (базовое поле без суффикса), фолбэк на русский — для турниров
    из админки, которые заполняются только по-русски. */
export const tl = (t, field, lang) =>
  (t && (t[`${field}_${lang}`] || t[`${field}_ru`] || t[field])) || '';

export const NAV_KEYS = [
  ['home', 'nav_home'],
  ['tournaments', 'nav_tournaments'],
  ['news', 'nav_news'],
  ['live', 'nav_live'],
  ['about', 'nav_about'],
];

export const DIRECTIONS_RU = [
  { icon: 'trophy', title: 'Турниры и кубки', text: 'FIFA OPEN, CS2 OPEN, MCA League и сезонные кубки — участвовать может любой житель региона.' },
  { icon: 'cap', title: 'Лига', text: 'Единая лига для школьников и студентов: отбор сборной области и путёвки на республиканские старты.' },
  { icon: 'book', title: 'Академия', text: 'Обучение игроков, тренеров и судей: тактика, дисциплина, работа со стримом.' },
  { icon: 'video', title: 'Медиа и трансляции', text: 'Прямые эфиры в TikTok и на YouTube, обзоры, интервью и разбор матчей.' },
];
export const DIRECTIONS_KZ = [
  { icon: 'trophy', title: 'Турнирлер мен кубоктар', text: 'FIFA OPEN, CS2 OPEN, MCA League және маусымдық кубоктар — аймақтың кез келген тұрғыны қатыса алады.' },
  { icon: 'cap', title: 'Лига', text: 'Оқушылар мен студенттерге арналған бірыңғай лига: облыс құрамасын іріктеу және республикалық старттарға жолдама.' },
  { icon: 'book', title: 'Академия', text: 'Ойыншылар, жаттықтырушылар мен төрешілерді оқыту: тактика, тәртіп, стриммен жұмыс.' },
  { icon: 'video', title: 'Медиа және трансляциялар', text: 'TikTok пен YouTube-тегі тікелей эфирлер, шолулар, сұхбаттар мен матч талдауы.' },
];

// Счётчики на главной — редактируются из админки (Настройки), это сиды.
export const COUNTERS = [
  { value: 500, suffix: '+', label_ru: 'участников за сезон', label_kz: 'маусымдағы қатысушы' },
  { value: 72, suffix: '', label_ru: 'команд в базе', label_kz: 'базадағы команда' },
  { value: 4, suffix: '', label_ru: 'турниров проведено', label_kz: 'өткізілген турнир' },
  { value: 50, suffix: 'ч', label_ru: 'прямых трансляций', label_kz: 'тікелей эфир' },
];

export const NEWS = [
  {
    id: 'n1', cat_ru: 'Турниры', cat_kz: 'Турнирлер', date: '12.07.2026', hue: 8,
    title_ru: 'FIFA OPEN · СКО: Босния — чемпион области', title_kz: 'FIFA OPEN · СҚО: Босния — облыс чемпионы',
    ex_ru: 'В спортбаре SALEM прошёл финал по EA SPORTS FC 26. 40 участников, 8 групп и напряжённый плей-офф.',
    ex_kz: 'SALEM спортбарында EA SPORTS FC 26 финалы өтті. 40 қатысушы, 8 топ және тартысты плей-офф.',
    body_ru: [
      '12 июля в спортбаре SALEM прошёл финальный день FIFA OPEN · СКО по EA SPORTS FC 26. За кубок области боролись 40 участников, разбитых жеребьёвкой на 8 групп.',
      'В решающем матче сборная Боснии (Влад А.) обыграла Южную Корею со счётом 4:3. Бронза досталась Египту, а лучшим бомбардиром турнира стал чемпион — 42 гола за один игровой день.',
      'Федерация благодарит всех участников, судей и партнёров. Следующий крупный старт сезона — осенний CS2 OPEN.',
    ],
    body_kz: [
      '12 шілдеде SALEM спортбарында EA SPORTS FC 26 бойынша FIFA OPEN · СҚО финалдық күні өтті. Облыс кубогы үшін жеребе бойынша 8 топқа бөлінген 40 қатысушы бақталасты.',
      'Шешуші матчта Босния құрамасы (Влад А.) Оңтүстік Кореяны 4:3 есебімен ұтты. Қола — Египетте, ал турнирдің үздік бомбардирі чемпион атанды — бір ойын күнінде 42 гол.',
      'Федерация барлық қатысушылар, төрешілер мен серіктестерге алғыс білдіреді. Маусымның келесі ірі старты — күзгі CS2 OPEN.',
    ],
  },
  {
    id: 'n2', cat_ru: 'Анонсы', cat_kz: 'Анонстар', date: '01.07.2026', hue: 42,
    title_ru: 'Открыт набор в студенческую лигу CS2', title_kz: 'CS2 студенттік лигасына жинақ ашылды',
    ex_ru: 'Вузы Петропавловска собирают команды. Отбор — до конца месяца, старт группового этапа в сентябре.',
    ex_kz: 'Петропавл ЖОО-лары команда жинауда. Іріктеу — ай соңына дейін, топтық кезең қыркүйекте.',
    body_ru: [
      'Федерация открывает набор в студенческую лигу по Counter-Strike 2. Участвовать могут команды всех вузов и колледжей Северо-Казахстанской области.',
      'Отбор проходит до конца месяца, групповой этап стартует в сентябре. Лучшие команды получат путёвки на республиканские студенческие старты.',
      'Заявки принимаются через сайт федерации и в Telegram-канале. Количество мест ограничено.',
    ],
    body_kz: [
      'Федерация Counter-Strike 2 бойынша студенттік лигаға жинақ ашады. Солтүстік Қазақстан облысының барлық ЖОО мен колледж командалары қатыса алады.',
      'Іріктеу ай соңына дейін өтеді, топтық кезең қыркүйекте басталады. Үздік командалар республикалық студенттік старттарға жолдама алады.',
      'Өтінімдер федерация сайты мен Telegram арнасы арқылы қабылданады. Орын саны шектеулі.',
    ],
  },
  {
    id: 'n3', cat_ru: 'Федерация', cat_kz: 'Федерация', date: '20.06.2026', hue: 150,
    title_ru: 'Федерация подписала партнёрство с СКУ', title_kz: 'Федерация СҚУ-мен серіктестікке қол қойды',
    ex_ru: 'Северо-Казахстанский университет станет площадкой для студенческих и школьных турниров сезона.',
    ex_kz: 'Солтүстік Қазақстан университеті маусымның студенттік және мектеп турнирлерінің алаңы болады.',
    body_ru: [
      'Федерация киберспорта СКО и СКУ им. М. Козыбаева подписали соглашение о партнёрстве. Университет предоставит площадки для студенческих и школьных турниров сезона.',
      'Сотрудничество включает совместные образовательные программы, поддержку студенческой лиги и развитие киберспортивной инфраструктуры в регионе.',
      'Первые турниры на новой площадке пройдут уже осенью 2026 года.',
    ],
    body_kz: [
      'СҚО киберспорт федерациясы мен М. Қозыбаев атындағы СҚУ серіктестік туралы келісімге қол қойды. Университет маусымның студенттік және мектеп турнирлеріне алаң береді.',
      'Ынтымақтастық бірлескен білім беру бағдарламаларын, студенттік лиганы қолдауды және аймақтағы киберспорт инфрақұрылымын дамытуды қамтиды.',
      'Жаңа алаңдағы алғашқы турнирлер 2026 жылдың күзінде өтеді.',
    ],
  },
  {
    id: 'n4', cat_ru: 'Обучение', cat_kz: 'Оқыту', date: '10.06.2026', hue: 265,
    title_ru: 'Стартовала школа судей и организаторов', title_kz: 'Төрешілер мен ұйымдастырушылар мектебі басталды',
    ex_ru: 'Бесплатный курс по проведению матчей, работе с турнирными сетками и стримом.',
    ex_kz: 'Матч өткізу, турнир торымен және стриммен жұмыс бойынша тегін курс.',
    body_ru: [
      'Федерация запускает бесплатную школу судей и организаторов. Курс рассчитан на всех, кто хочет проводить матчи, работать с турнирными сетками и вести трансляции.',
      'Программа включает теорию правил, практику судейства на реальных турнирах и основы работы со стримом. По итогам — сертификат федерации.',
      'Записаться можно через сайт и Telegram-канал федерации.',
    ],
    body_kz: [
      'Федерация төрешілер мен ұйымдастырушылардың тегін мектебін іске қосады. Курс матч өткізгісі, турнир торымен жұмыс істегісі және трансляция жүргізгісі келетіндерге арналған.',
      'Бағдарлама ережелер теориясын, нақты турнирлердегі төрелік тәжірибесін және стриммен жұмыс негіздерін қамтиды. Қорытындысы бойынша — федерация сертификаты.',
      'Тіркелу федерация сайты мен Telegram арнасы арқылы жүреді.',
    ],
  },
  {
    id: 'n5', cat_ru: 'Турниры', cat_kz: 'Турнирлер', date: '28.05.2026', hue: 8,
    title_ru: 'CS2 OPEN возвращается осенью', title_kz: 'CS2 OPEN күзде оралады',
    ex_ru: 'Осенний сезон открытого турнира по Counter-Strike 2. Призовой фонд и формат — скоро.',
    ex_kz: 'Counter-Strike 2 ашық турнирінің күзгі маусымы. Жүлде қоры мен формат — жақында.',
  },
  {
    id: 'n6', cat_ru: 'Медиа', cat_kz: 'Медиа', date: '15.05.2026', hue: 200,
    title_ru: 'Запущен YouTube-канал федерации', title_kz: 'Федерацияның YouTube арнасы іске қосылды',
    ex_ru: 'Записи матчей, хайлайты и разборы. Подписывайтесь, чтобы не пропускать эфиры.',
    ex_kz: 'Матч жазбалары, хайлайттар мен талдаулар. Эфирлерді жіберіп алмау үшін жазылыңыз.',
    body_ru: [
      'У федерации появился официальный YouTube-канал. Здесь будут полные записи матчей, хайлайты, интервью с игроками и разборы ключевых встреч.',
      'Прямые трансляции турниров идут параллельно на Twitch и YouTube. Подписывайтесь, чтобы не пропускать эфиры и получать уведомления о новых видео.',
      'Первые записи финалов FIFA OPEN уже доступны на канале.',
    ],
    body_kz: [
      'Федерацияның ресми YouTube арнасы пайда болды. Мұнда матчтардың толық жазбалары, хайлайттар, ойыншылармен сұхбаттар мен басты кездесулердің талдауы болады.',
      'Турнирлердің тікелей трансляциясы Twitch пен YouTube-та қатар жүреді. Эфирлерді жіберіп алмау және жаңа видеолар туралы хабарлама алу үшін жазылыңыз.',
      'FIFA OPEN финалдарының алғашқы жазбалары арнада қолжетімді.',
    ],
  },
];

export const PARTNERS = [
  { mono: 'EC', name: 'ОО «Ecotime»', role_ru: 'Организатор', role_kz: 'Ұйымдастырушы', badge: 'linear-gradient(140deg,#E11217,#8E0A0D)' },
  { mono: 'SA', name: 'Спортбар SALEM', role_ru: 'Спонсор · площадка', role_kz: 'Демеуші · алаң', badge: 'linear-gradient(140deg,#E6B73C,#B98B17)' },
  { mono: 'СКУ', name: 'СКУ им. Козыбаева', role_ru: 'Партнёр · площадка', role_kz: 'Серіктес · алаң', badge: 'linear-gradient(140deg,#2A6FDB,#123a7a)' },
  { mono: 'МП', name: 'Молодёжная политика СКО', role_ru: 'Поддержка', role_kz: 'Қолдау', badge: 'linear-gradient(140deg,#1F8A5B,#0d4a30)' },
  { mono: 'GG', name: 'GG Store', role_ru: 'Мерч · призы', role_kz: 'Мерч · жүлде', badge: 'linear-gradient(140deg,#7A3AE1,#3a1a78)' },
  { mono: 'PS', name: 'PlayZone', role_ru: 'Игровой клуб', role_kz: 'Ойын клубы', badge: 'linear-gradient(140deg,#E1602A,#8a3212)' },
];

export const SOCIALS = [
  { name: 'Telegram', href: 'https://t.me/fc_sko', icon: 'telegram' },
  { name: 'YouTube', href: 'https://youtube.com/@sko_esports', icon: 'youtube' },
  { name: 'TikTok', href: TIKTOK_LIVE_URL, icon: 'tiktok' },
];

// ============ турниры ============

// MCA — Mobile Legends Central Asia League · Квалификации #1 (первые квалы).
// id оставлен прежним, чтобы не осиротить уже созданные на бэке команды/заявки.
export const MLBB_TOUR = {
  id: 'mlbb-women-2026', disc: 'MLBB', title: 'MCA League — Квалификации #1', game: 'Mobile Legends: Bang Bang', season: '2026',
  title_kz: 'MCA League — Іріктеу #1',
  qualifierNo: 1, matchesOpen: true, image: '/assets/mca-logo.jpg', regOpen: false,
  status: 'done', date_ru: '19 июля 2026, 20:00', place_ru: 'Онлайн · Казахстан (KZ)', platform: 'Mobile',
  date_kz: '2026 ж. 19 шілде, 20:00', place_kz: 'Онлайн · Қазақстан (KZ)',
  regClose_ru: 'до 19 июля, 18:00', regClose_kz: '19 шілдеге дейін, 18:00',
  format_ru: '5×5 · Single Elimination', players: 0, hue: 275, hasData: 'mlbb',
  format_kz: '5×5 · Single Elimination',
  slots: 2, prizeUsd: '5 000 $', prize_ru: '2 слота в MCA League', prize_kz: 'MCA League-те 2 слот',
  org: 'QNEA — Central Asia Department', tgPost: 'https://t.me/QNEACAD',
  // Итоги квалификаций #1 (финал r5m0, 19 июля 2026): Bumblebees 20:2 The 2z.
  champ: 'Bumblebees', champPlayer: 'капитан тәштік · финал 20:2',
  runnerUp: 'The 2z',
  about_ru: 'QNEA — Central Asia Department открывает регистрацию на квалификационный этап MCA — Mobile Legends Central Asia League. К участию допускаются исключительно команды из Республики Казахстан. По итогам первых квалификаций две лучшие команды получат право сыграть в первом сезоне MCA League и представят Казахстан в соревновании с сильнейшими коллективами Центральной Азии.',
  about_kz: 'QNEA — Central Asia Department MCA — Mobile Legends Central Asia League іріктеу кезеңіне тіркеуді ашады. Қатысуға тек Қазақстан Республикасының командалары жіберіледі. Алғашқы іріктеу қорытындысы бойынша үздік екі команда MCA League-тің бірінші маусымына жолдама алып, Орталық Азияның мықты құрамаларымен бақталаста Қазақстанды таныстырады.',
};

// MCA · Квалификации #2 (вторые квалы) — приём заявок открыт.
// ВАЖНО: свой tour_id, чтобы заявки/сетка не смешались с первыми квалами
// (см. MLBB_TOUR_ID_Q2 в fed/mlbb/store.js и REG_CLOSED_TOURS на бэке).
export const MLBB_TOUR_Q2 = {
  id: 'mlbb-mca-quals2-2026', disc: 'MLBB', title: 'MCA League — Квалификации #2', game: 'Mobile Legends: Bang Bang', season: '2026',
  title_kz: 'MCA League — Іріктеу #2',
  qualifierNo: 2, matchesOpen: false, image: '/assets/mca-logo.jpg', regOpen: true,
  // Дат нет намеренно: идёт только приём заявок, старт матчей и дедлайн
  // регистрации объявим позже. Пустые date/regClose — плитки и строки с
  // этими фактами на витрине просто не показываются.
  status: 'soon', place_ru: 'Онлайн · Казахстан (KZ)', platform: 'Mobile',
  place_kz: 'Онлайн · Қазақстан (KZ)',
  format_ru: '5×5 · Single Elimination', players: 0, hue: 275, hasData: 'mlbb',
  format_kz: '5×5 · Single Elimination',
  slots: 2, prizeUsd: '5 000 $', prize_ru: '2 слота в MCA League', prize_kz: 'MCA League-те 2 слот',
  org: 'QNEA — Central Asia Department', tgPost: 'https://t.me/QNEACAD',
  about_ru: 'QNEA — Central Asia Department открывает регистрацию на вторые квалификации MCA — Mobile Legends Central Asia League. К участию допускаются исключительно команды из Республики Казахстан. По итогам вторых квалификаций две лучшие команды получат право сыграть в первом сезоне MCA League и представят Казахстан в соревновании с сильнейшими коллективами Центральной Азии.',
  about_kz: 'QNEA — Central Asia Department MCA — Mobile Legends Central Asia League екінші іріктеуіне тіркеуді ашады. Қатысуға тек Қазақстан Республикасының командалары жіберіледі. Екінші іріктеу қорытындысы бойынша үздік екі команда MCA League-тің бірінші маусымына жолдама алып, Орталық Азияның мықты құрамаларымен бақталаста Қазақстанды таныстырады.',
  rules_ru: [
    'MCA — Mobile Legends Central Asia League · вторые квалификации',
    'К участию допускаются только команды из Республики Казахстан',
    'Формат квалификаций: онлайн · 5×5 · Single Elimination',
    'Регистрация открыта · даты старта матчей будут объявлены отдельно',
    'По итогам — 2 слота в первом сезоне MCA League',
    'MCA League: призовой фонд 5 000 USD · финальная стадия LAN · старт в августе',
    'Регистрация команды — через сайт: профиль игрока (игровой ID, никнейм, Telegram) + команда из 5 игроков',
    'Команды, игравшие первые квалификации, могут заявиться снова',
  ],
  rules_kz: [
    'MCA — Mobile Legends Central Asia League · екінші іріктеу',
    'Қатысуға тек Қазақстан Республикасының командалары жіберіледі',
    'Іріктеу форматы: онлайн · 5×5 · Single Elimination',
    'Тіркелу ашық · матч басталу күні бөлек жарияланады',
    'Қорытынды бойынша — MCA League бірінші маусымына 2 слот',
    'MCA League: жүлде қоры 5 000 USD · финалдық кезең LAN · тамызда басталады',
    'Команданы тіркеу — сайт арқылы: ойыншы профилі (ойын ID, никнейм, Telegram) + 5 ойыншыдан тұратын команда',
    'Алғашқы іріктеуде ойнаған командалар қайта тіркеле алады',
  ],
};

// Все MLBB-турниры с собственной механикой (регистрация/команды/сетка).
// Порядок = порядок на витрине: активные квалы первыми.
export const MLBB_TOURS = [MLBB_TOUR_Q2, MLBB_TOUR];

export const MLBB_RULES_RU = [
  'MCA — Mobile Legends Central Asia League · квалификационный этап',
  'К участию допускаются только команды из Республики Казахстан',
  'Формат квалификаций: онлайн · 5×5 · Single Elimination',
  'Регистрация: до 19 июля, 18:00 · старт матчей: 19 июля, 20:00',
  'По итогам — 2 слота в первом сезоне MCA League',
  'MCA League: призовой фонд 5 000 USD · финальная стадия LAN · старт в августе',
  'Регистрация команды — через сайт: профиль игрока (игровой ID, никнейм, Telegram) + команда из 5 игроков',
  'Точная дата старта лиги будет опубликована в конце июля',
];
export const MLBB_RULES_KZ = [
  'MCA — Mobile Legends Central Asia League · іріктеу кезеңі',
  'Қатысуға тек Қазақстан Республикасының командалары жіберіледі',
  'Іріктеу форматы: онлайн · 5×5 · Single Elimination',
  'Тіркелу: 19 шілдеге дейін, 18:00 · матч басталуы: 19 шілде, 20:00',
  'Қорытынды бойынша — MCA League бірінші маусымына 2 слот',
  'MCA League: жүлде қоры 5 000 USD · финалдық кезең LAN · тамызда басталады',
  'Команданы тіркеу — сайт арқылы: ойыншы профилі (ойын ID, никнейм, Telegram) + 5 ойыншыдан тұратын команда',
  'Лига стартының нақты күні шілде соңында жарияланады',
];

export const TOURNAMENTS = [
  ...MLBB_TOURS,
  {
    id: 'fifa-open-2026', disc: 'FIFA', title: 'FIFA OPEN · СКО', game: 'EA SPORTS FC 26', season: '2026',
    title_kz: 'FIFA OPEN · СҚО',
    status: 'done', date_ru: '12 июля 2026', place_ru: 'Спортбар SALEM · Петропавловск', platform: 'PlayStation 5',
    date_kz: '2026 жылғы 12 шілде', place_kz: 'SALEM спортбары · Петропавл',
    format_ru: '8 групп → плей-офф с 1/8', players: 40, prize_ru: 'Кубок СКО · медали · мерч',
    format_kz: '8 топ → 1/8 финалдан плей-офф', prize_kz: 'СҚО кубогы · медальдар · мерч',
    champ: 'Босния', champCc: 'ba', champPlayer: 'Влад А.', hue: 150, hasData: 'fifa',
    about_ru: 'Областной футбольный киберспортивный чемпионат в формате чемпионата мира: 40 участников, 8 групп, затем плей-офф с 1/8 финала. Сборные раздаёт жеребьёвка в день турнира — всё проходит в спортбаре SALEM.',
    about_kz: 'Әлем чемпионаты форматындағы облыстық футбол киберспорт чемпионаты: 40 қатысушы, 8 топ, содан кейін 1/8 финалдан басталатын плей-офф. Құрамаларды турнир күні жеребе анықтайды — бәрі SALEM спортбарында өтеді.',
  },
  {
    id: 'cs2-open-2026', disc: 'CS2', title: 'CS2 OPEN · СКО', game: 'Counter-Strike 2', season: '2026',
    title_kz: 'CS2 OPEN · СҚО',
    status: 'done', date_ru: '20–21 июня 2026', place_ru: 'СКУ им. Козыбаева · корпус 1', platform: 'ПК',
    date_kz: '2026 жылғы 20–21 маусым', place_kz: 'М. Қозыбаев ат. СҚУ · 1-корпус',
    format_ru: 'Single Elimination · BO1 / финал BO3', players: 90, prize_ru: '200 000 ₸',
    format_kz: 'Single Elimination · BO1 / финал BO3', prize_kz: '200 000 ₸',
    champ: 'qNatek', champCc: '', champPlayer: 'chinZz-', hue: 42, hasData: 'cs',
    about_ru: 'Открытый турнир по Counter-Strike 2 для школьников и студентов СКО. Single Elimination, финалы — на площадке СКУ им. Козыбаева.',
    about_kz: 'СҚО оқушылары мен студенттеріне арналған Counter-Strike 2 ашық турнирі. Single Elimination, финалдар — Қозыбаев атындағы СҚУ алаңында.',
  },
  {
    id: 'cs2-autumn-2026', disc: 'CS2', title: 'CS2 OPEN · Осень', game: 'Counter-Strike 2', season: '2026',
    title_kz: 'CS2 OPEN · Күз',
    status: 'soon', date_ru: 'октябрь 2026', place_ru: 'уточняется', platform: 'ПК',
    date_kz: '2026 жылғы қазан', place_kz: 'нақтылануда',
    format_ru: 'Double Elimination', players: 0, prize_ru: 'призовой фонд уточняется', hue: 8, hasData: false,
    format_kz: 'Double Elimination', prize_kz: 'жүлде қоры нақтылануда',
    about_ru: 'Осенний сезон открытого турнира по Counter-Strike 2. Формат, площадка и призовой фонд — скоро.',
    about_kz: 'Counter-Strike 2 ашық турнирінің күзгі маусымы. Формат, алаң және жүлде қоры — жақында.',
  },
  {
    id: 'school-league-2026', disc: 'ЛИГА', title: 'Школьная лига', game: 'CS2 · EA FC', season: '2026',
    title_kz: 'Мектеп лигасы',
    status: 'soon', date_ru: 'сентябрь 2026', place_ru: 'СКУ им. Козыбаева', platform: 'ПК · PS5',
    date_kz: '2026 жылғы қыркүйек', place_kz: 'М. Қозыбаев атындағы СҚУ',
    format_ru: 'групповой + плей-офф', players: 0, prize_ru: 'кубки · медали', hue: 210, hasData: false,
    format_kz: 'топтық кезең + плей-офф', prize_kz: 'кубоктар · медальдар',
    about_ru: 'Школьная киберспортивная лига СКО по CS2 и EA SPORTS FC. Первый шаг в турнирный киберспорт под присмотром федерации.',
    about_kz: 'СҚО-ның CS2 және EA SPORTS FC бойынша мектеп киберспорт лигасы. Федерация бақылауындағы турнирлік киберспортқа алғашқы қадам.',
  },
];

export const FIFA_GROUPS = [
  { id: 'A', rows: [['Канат', 'Португалия', 'pt', [3, 0, 1, 21, 8, 9]], ['Арман К.', 'Египет', 'eg', [3, 0, 1, 12, 10, 9]], ['Улан Р.', 'Аргентина', 'ar', [2, 1, 1, 15, 10, 7]], ['Кузьма А.', 'Марокко', 'ma', [1, 0, 3, 5, 12, 3]], ['Аркат А.', 'Хорватия', 'hr', [0, 1, 3, 1, 14, 1]]] },
  { id: 'B', rows: [['Егор П.', 'Панама', 'pa', [4, 0, 0, 13, 3, 12]], ['Мурат Д.', 'Шотландия', 'gb-sct', [3, 0, 1, 17, 8, 9]], ['Кизат А.', 'Конго', 'cg', [2, 0, 2, 12, 7, 6]], ['Сын Алмаз', 'Германия', 'de', [1, 0, 3, 8, 20, 3]], ['Евгений Г.', 'Австралия', 'au', [0, 0, 4, 0, 12, 0]]] },
  { id: 'C', rows: [['Ахат К.', 'Гана', 'gh', [4, 0, 0, 18, 4, 12]], ['Малик А.', 'Испания', 'es', [3, 0, 1, 19, 11, 9]], ['Артур А.', 'Англия', 'gb-eng', [1, 0, 3, 10, 12, 3]], ['Тобыл К.', 'Швейцария', 'ch', [1, 0, 3, 9, 11, 3]], ['Максим Ш.', 'Иран', 'ir', [1, 0, 3, 3, 21, 3]]] },
  { id: 'D', rows: [['Алмаз З.', 'Колумбия', 'co', [2, 2, 0, 10, 4, 8]], ['Магомед Д.', 'Кот-д’Ивуар', 'ci', [2, 2, 0, 9, 6, 8]], ['Арлан', 'Сенегал', 'sn', [0, 3, 0, 6, 6, 3]], ['Сергей Ш.', 'Кюрасао', 'cw', [0, 2, 2, 4, 7, 2]], ['Нурсултан Б.', 'Чехия', 'cz', [0, 1, 2, 2, 8, 1]]] },
  { id: 'E', rows: [['Никита Л.', 'Австрия', 'at', [4, 0, 0, 20, 6, 12]], ['Александр К.', 'Япония', 'jp', [3, 0, 1, 14, 9, 9]], ['Игорь Д.', 'Бразилия', 'br', [2, 0, 2, 13, 9, 6]], ['Жорик И.', 'Норвегия', 'no', [1, 0, 3, 4, 13, 3]], ['Ростислав Х.', 'Уругвай', 'uy', [0, 0, 4, 5, 19, 0]]] },
  { id: 'F', rows: [['Арғын Ш.', 'Кабо-Верде', 'cv', [3, 1, 0, 13, 2, 10]], ['Руслан Л.', 'Франция', 'fr', [1, 3, 0, 8, 5, 6]], ['Сергей Н.', 'ЮАР', 'za', [1, 2, 1, 10, 11, 5]], ['Даниил И.', 'Тунис', 'tn', [1, 2, 1, 7, 8, 5]], ['Роман И.', 'Парагвай', 'py', [0, 0, 4, 0, 12, 0]]] },
  { id: 'G', rows: [['Асет У.', 'Иордания', 'jo', [4, 0, 0, 13, 1, 12]], ['Нурым К.', 'Гаити', 'ht', [3, 0, 1, 11, 7, 9]], ['Даниял А.', 'Узбекистан', 'uz', [2, 0, 2, 8, 11, 6]], ['Бек И.', 'Бельгия', 'be', [1, 0, 3, 6, 7, 3]], ['Виталий А.', 'Нидерланды', 'nl', [0, 0, 4, 0, 12, 0]]] },
  { id: 'H', rows: [['Влад А.', 'Босния', 'ba', [3, 1, 0, 20, 7, 10]], ['Нурсултан К.', 'Юж. Корея', 'kr', [3, 1, 0, 15, 7, 10]], ['Алдияр Ш.', 'Канада', 'ca', [1, 1, 2, 11, 15, 4]], ['Адиль У.', 'Швеция', 'se', [1, 0, 3, 9, 13, 3]], ['Сабит И.', 'Алжир', 'dz', [0, 1, 3, 2, 15, 1]]] },
];

export const FIFA_BRACKET = [
  {
    title_ru: '1/8 финала', title_kz: '1/8 финал', matches: [
      { a: { n: 'Канат', c: 'Португалия', cc: 'pt', g: 3 }, b: { n: 'Мурат Д.', c: 'Шотландия', cc: 'gb-sct', g: 4, win: true } },
      { a: { n: 'Ахат К.', c: 'Гана', cc: 'gh', g: 4, win: true }, b: { n: 'Магомед Д.', c: 'Кот-д’Ивуар', cc: 'ci', g: 1 } },
      { a: { n: 'Никита Л.', c: 'Австрия', cc: 'at', g: 7, win: true }, b: { n: 'Руслан Л.', c: 'Франция', cc: 'fr', g: 0 } },
      { a: { n: 'Асет У.', c: 'Иордания', cc: 'jo', g: 0 }, b: { n: 'Нурсултан К.', c: 'Юж. Корея', cc: 'kr', g: 5, win: true } },
      { a: { n: 'Егор П.', c: 'Панама', cc: 'pa', g: 1 }, b: { n: 'Арман К.', c: 'Египет', cc: 'eg', g: 2, win: true } },
      { a: { n: 'Алмаз З.', c: 'Колумбия', cc: 'co', g: 4 }, b: { n: 'Малик А.', c: 'Испания', cc: 'es', g: 5, win: true } },
      { a: { n: 'Арғын Ш.', c: 'Кабо-Верде', cc: 'cv', g: 6, win: true }, b: { n: 'Александр К.', c: 'Япония', cc: 'jp', g: 5 } },
      { a: { n: 'Влад А.', c: 'Босния', cc: 'ba', g: 9, win: true }, b: { n: 'Нурым К.', c: 'Гаити', cc: 'ht', g: 2 } },
    ],
  },
  {
    title_ru: '1/4 финала', title_kz: '1/4 финал', matches: [
      { a: { n: 'Мурат Д.', c: 'Шотландия', cc: 'gb-sct', g: 4, win: true }, b: { n: 'Ахат К.', c: 'Гана', cc: 'gh', g: 3 } },
      { a: { n: 'Никита Л.', c: 'Австрия', cc: 'at', g: 1 }, b: { n: 'Нурсултан К.', c: 'Юж. Корея', cc: 'kr', g: 5, win: true } },
      { a: { n: 'Арман К.', c: 'Египет', cc: 'eg', g: 9, win: true }, b: { n: 'Малик А.', c: 'Испания', cc: 'es', g: 4 } },
      { a: { n: 'Арғын Ш.', c: 'Кабо-Верде', cc: 'cv', g: 4 }, b: { n: 'Влад А.', c: 'Босния', cc: 'ba', g: 5, win: true } },
    ],
  },
  {
    title_ru: 'Полуфиналы', title_kz: 'Жартылай финал', matches: [
      { a: { n: 'Мурат Д.', c: 'Шотландия', cc: 'gb-sct', g: 2 }, b: { n: 'Нурсултан К.', c: 'Юж. Корея', cc: 'kr', g: 3, win: true } },
      { a: { n: 'Арман К.', c: 'Египет', cc: 'eg', g: 2 }, b: { n: 'Влад А.', c: 'Босния', cc: 'ba', g: 4, win: true } },
    ],
  },
  {
    title_ru: 'Финал', title_kz: 'Финал', matches: [
      { label: 'ФИНАЛ', a: { n: 'Нурсултан К.', c: 'Юж. Корея', cc: 'kr', g: 3 }, b: { n: 'Влад А.', c: 'Босния', cc: 'ba', g: 4, win: true } },
      { label: 'ЗА 3-Е МЕСТО', a: { n: 'Мурат Д.', c: 'Шотландия', cc: 'gb-sct', g: 1 }, b: { n: 'Арман К.', c: 'Египет', cc: 'eg', g: 4, win: true } },
    ],
  },
];

export const FIFA_PLAYERS = [
  { num: 1, n: 'Аркат А.', c: 'Хорватия', cc: 'hr', g: 'A' }, { num: 2, n: 'Сын Алмаз', c: 'Германия', cc: 'de', g: 'B' }, { num: 3, n: 'Алдияр Ш.', c: 'Канада', cc: 'ca', g: 'H' }, { num: 4, n: 'Сергей Н.', c: 'ЮАР', cc: 'za', g: 'F' }, { num: 5, n: 'Евгений Г.', c: 'Австралия', cc: 'au', g: 'B' }, { num: 6, n: 'Руслан Л.', c: 'Франция', cc: 'fr', g: 'F' }, { num: 7, n: 'Нурсултан Б.', c: 'Чехия', cc: 'cz', g: 'D' }, { num: 8, n: 'Ростислав Х.', c: 'Уругвай', cc: 'uy', g: 'E' }, { num: 9, n: 'Виталий А.', c: 'Нидерланды', cc: 'nl', g: 'G' }, { num: 10, n: 'Роман И.', c: 'Парагвай', cc: 'py', g: 'F' },
  { num: 11, n: 'Жорик И.', c: 'Норвегия', cc: 'no', g: 'E' }, { num: 12, n: 'Сергей Ш.', c: 'Кюрасао', cc: 'cw', g: 'D' }, { num: 13, n: 'Игорь Д.', c: 'Бразилия', cc: 'br', g: 'E' }, { num: 14, n: 'Александр К.', c: 'Япония', cc: 'jp', g: 'E' }, { num: 15, n: 'Даниял А.', c: 'Узбекистан', cc: 'uz', g: 'G' }, { num: 16, n: 'Арман К.', c: 'Египет', cc: 'eg', g: 'A' }, { num: 17, n: 'Арғын Ш.', c: 'Кабо-Верде', cc: 'cv', g: 'F' }, { num: 18, n: 'Никита Л.', c: 'Австрия', cc: 'at', g: 'E' }, { num: 19, n: 'Даниил И.', c: 'Тунис', cc: 'tn', g: 'F' }, { num: 20, n: 'Бек И.', c: 'Бельгия', cc: 'be', g: 'G' },
  { num: 21, n: 'Магомед Д.', c: 'Кот-д’Ивуар', cc: 'ci', g: 'D' }, { num: 22, n: 'Влад А.', c: 'Босния', cc: 'ba', g: 'H' }, { num: 23, n: 'Кузьма А.', c: 'Марокко', cc: 'ma', g: 'A' }, { num: 24, n: 'Канат', c: 'Португалия', cc: 'pt', g: 'A' }, { num: 25, n: 'Адиль У.', c: 'Швеция', cc: 'se', g: 'H' }, { num: 26, n: 'Асет У.', c: 'Иордания', cc: 'jo', g: 'G' }, { num: 27, n: 'Тобыл К.', c: 'Швейцария', cc: 'ch', g: 'C' }, { num: 28, n: 'Малик А.', c: 'Испания', cc: 'es', g: 'C' }, { num: 29, n: 'Мурат Д.', c: 'Шотландия', cc: 'gb-sct', g: 'B' }, { num: 30, n: 'Нурсултан К.', c: 'Юж. Корея', cc: 'kr', g: 'H' },
  { num: 31, n: 'Алмаз З.', c: 'Колумбия', cc: 'co', g: 'D' }, { num: 32, n: 'Максим Ш.', c: 'Иран', cc: 'ir', g: 'C' }, { num: 33, n: 'Кизат А.', c: 'Конго', cc: 'cg', g: 'B' }, { num: 34, n: 'Ахат К.', c: 'Гана', cc: 'gh', g: 'C' }, { num: 35, n: 'Улан Р.', c: 'Аргентина', cc: 'ar', g: 'A' }, { num: 36, n: 'Артур А.', c: 'Англия', cc: 'gb-eng', g: 'C' }, { num: 37, n: 'Сабит И.', c: 'Алжир', cc: 'dz', g: 'H' }, { num: 38, n: 'Егор П.', c: 'Панама', cc: 'pa', g: 'B' }, { num: 39, n: 'Арлан', c: 'Сенегал', cc: 'sn', g: 'D' }, { num: 40, n: 'Нурым К.', c: 'Гаити', cc: 'ht', g: 'G' },
];

export const WINNERS = [
  { place: 2, cls: 'silver', lab_ru: 'СЕРЕБРО', lab_kz: 'КҮМІС', team: 'Юж. Корея', cc: 'kr', player: 'Нурсултан К.', note_ru: 'Финал · 3:4', note_kz: 'Финал · 3:4' },
  { place: 1, cls: 'gold', lab_ru: 'ЧЕМПИОН', lab_kz: 'ЧЕМПИОН', team: 'Босния', cc: 'ba', player: 'Влад А.', note_ru: 'Кубок FIFA OPEN · СКО 2026', note_kz: 'FIFA OPEN · СҚО 2026 кубогы' },
  { place: 3, cls: 'bronze', lab_ru: 'БРОНЗА', lab_kz: 'ҚОЛА', team: 'Египет', cc: 'eg', player: 'Арман К.', note_ru: 'Матч за 3 место · 4:1', note_kz: '3-орын матчы · 4:1' },
];
export const WN_STATS = [['40', 'участников', 'қатысушы'], ['8', 'групп', 'топ'], ['95', 'матчей', 'матч'], ['499', 'голов', 'гол']];

export const CS2_BRACKET = [
  { title_ru: '1/4 финала', title_kz: '1/4 финал', matches: [{ a: { n: 'Five Nignt Kings', g: '' }, b: { n: 'FrytoNavi', g: 1, win: true } }, { a: { n: 'Qumys x Skalisto', g: 1, win: true }, b: { n: 'Poltavka', g: '' } }] },
  { title_ru: 'Полуфиналы', title_kz: 'Жартылай финал', matches: [{ a: { n: 'Team Winstrike', g: 2, win: true }, b: { n: 'FrytoNavi', g: 0 } }, { a: { n: 'qNatek', g: 2, win: true }, b: { n: 'Qumys x Skalisto', g: 0 } }] },
  { title_ru: 'Финал', title_kz: 'Финал', matches: [{ label: 'ЗА 3-Е МЕСТО', a: { n: 'FrytoNavi', g: 0 }, b: { n: 'Qumys x Skalisto', g: 1, win: true } }, { label: 'ГРАНД-ФИНАЛ', a: { n: 'Team Winstrike', g: 0 }, b: { n: 'qNatek', g: 2, win: true } }] },
];
export const CS2_TEAMS = [['Team Winstrike', '_Yamamoto_'], ['qNatek', 'chinZz-'], ['Qumys x Skalisto', 'SpawiK'], ['FrytoNavi', 'Akela_'], ['Five Nignt Kings', 'str1ks'], ['Poltavka', 'zayac07'], ['Team Spilis', 'ZLATAN_MENTALITY'], ['Mamlyutka', 'muiercy'], ['wild', 'Amazon'], ['Rayson', 'Lasfet'], ['VAG', 'Foyles'], ['SIXSEVEN', 'tarakan4ik'], ['CyberLab', '_isee'], ['Team Solute', 'domino'], ['Deal_Ducks', 'Chip6996']];

export const FIFA_RULES_RU = ['Платформа PlayStation 5 · EA SPORTS FC 26 · режим Kick-Off', 'Играем за сборные — команды раздаёт жеребьёвка в день турнира', 'Тайм 6 минут · обычная скорость', 'Группы: победа — 3 очка, ничья — 1 очко', 'В плей-офф выходят два лучших игрока из каждой группы', 'Плей-офф: ничья — доп. время и пенальти', 'Групповые туры играются по 4 матча на столах 1–4', 'Неявка более 10 минут — техническое поражение 0:3'];
export const FIFA_RULES_KZ = ['Платформа PlayStation 5 · EA SPORTS FC 26 · Kick-Off режимі', 'Құрамалармен ойнаймыз — командаларды турнир күні жеребе бөледі', 'Тайм 6 минут · қалыпты жылдамдық', 'Топтар: жеңіс — 3 ұпай, тең ойын — 1 ұпай', 'Плей-оффқа әр топтан үздік екі ойыншы шығады', 'Плей-офф: тең ойын — қосымша уақыт пен пенальти', 'Топтық турлар 1–4 үстелдерде 4 матчтан ойналады', '10 минуттан астам келмеу — 0:3 техникалық жеңіліс'];
export const CS2_RULES_RU = ['Counter-Strike 2 · официальные карты', 'Составы: 5 основных + 1 запасной', 'Single Elimination · BO1, финал BO3', 'Только школьники и студенты СКО'];
export const CS2_RULES_KZ = ['Counter-Strike 2 · ресми карталар', 'Құрам: 5 негізгі + 1 қосалқы', 'Single Elimination · BO1, финал BO3', 'Тек СҚО оқушылары мен студенттері'];

// Команда федерации — заполняется реальными людьми через админку
// («Команда»). Пока список пуст, секция на странице «О федерации» скрыта.
export const TEAM = [];

export const PROJECTS = [
  { ic: 'cap', status: 'soon', title_ru: 'Лига', title_kz: 'Лига', d_ru: 'Единая лига федерации для школьников и студентов: турниры по CS2, EA FC и MLBB, отбор в сборную области.', d_kz: 'Оқушылар мен студенттерге арналған федерацияның бірыңғай лигасы: CS2, EA FC және MLBB турнирлері, облыс құрамасына іріктеу.', meta_ru: 'скоро', meta_kz: 'жақында' },
  { ic: 'book', status: 'soon', title_ru: 'Академия', title_kz: 'Академия', d_ru: 'Обучение игроков, тренеров и судей: тактика, дисциплина и работа со стримом.', d_kz: 'Ойыншылар, жаттықтырушылар мен төрешілерді оқыту: тактика, тәртіп және стрим.', meta_ru: 'скоро', meta_kz: 'жақында' },
  { ic: 'video', status: 'active', title_ru: 'Медиа и трансляции', title_kz: 'Медиа және трансляциялар', d_ru: 'Прямые эфиры в TikTok и на YouTube, обзоры, интервью и разбор матчей.', d_kz: 'TikTok пен YouTube тікелей эфирлері, шолулар, сұхбаттар мен матч талдауы.', meta_ru: '50 ч эфира', meta_kz: '50 сағ эфир' },
  { ic: 'trophy', status: 'soon', title_ru: 'Сборная области', title_kz: 'Облыс құрамасы', d_ru: 'Отбор и подготовка сборной СКО к республиканским и национальным стартам.', d_kz: 'СҚО құрамасын республикалық және ұлттық старттарға іріктеу мен дайындау.', meta_ru: 'скоро', meta_kz: 'жақында' },
];

// Документы федерации — появятся, когда будут реальные PDF-файлы
// (загрузка — следующий этап). Пустой список скрывает секции на
// «О федерации» и показывает заглушку на «Регламентах».
export const DOCS = [];

export const VALUES = [
  { icon: 'scale', t_ru: 'Честная игра', t_kz: 'Әділ ойын', d_ru: 'Античит, квалифицированное судейство и прозрачные правила на каждом турнире.', d_kz: 'Античит, білікті төрелік және әр турнирдегі ашық ережелер.' },
  { icon: 'sprout', t_ru: 'Развитие талантов', t_kz: 'Талантты дамыту', d_ru: 'От школьной лиги до сборной области — понятный путь для каждого игрока.', d_kz: 'Мектеп лигасынан облыс құрамасына дейін — әр ойыншыға түсінікті жол.' },
  { icon: 'community', t_ru: 'Сообщество', t_kz: 'Қауымдастық', d_ru: 'Объединяем игроков, клубы, вузы и партнёров всего региона.', d_kz: 'Бүкіл аймақтың ойыншыларын, клубтарын, ЖОО мен серіктестерін біріктіреміз.' },
];

export const LIVE_SCHEDULE = {
  ru: [
    { t: '18:00', x: 'Открытие и чек-ин команд · MCA League MLBB' },
    { t: '18:30', x: 'Плей-офф · 1/8 и 1/4 финала' },
    { t: '21:00', x: 'Полуфиналы и финал квалификаций' },
  ],
  kz: [
    { t: '18:00', x: 'Ашылу және командалар чек-ині · MCA League MLBB' },
    { t: '18:30', x: 'Плей-офф · 1/8 және 1/4 финал' },
    { t: '21:00', x: 'Жартылай финал және іріктеу финалы' },
  ],
};

// Страница «Эфир» целиком редактируется в админке (контент-ключ 'live');
// значения ниже — стартовые, пока на сервере ничего не сохранено.
export const LIVE_DEFAULTS = {
  tiktokUser: TIKTOK_USER,
  twitchChannel: 'cybersqo',
  youtubeLiveUrl: '',
  youtube: 'https://youtube.com/@sko_esports',
  schedule_ru: LIVE_SCHEDULE.ru,
  schedule_kz: LIVE_SCHEDULE.kz,
};

export const TICKER_ITEMS = {
  ru: [
    { tag: 'FIFA OPEN', text: 'Босния — чемпион области' },
    { tag: 'CS2 OPEN', text: 'осенний сезон — скоро' },
    { tag: 'ЛИГА', text: 'набор в студенческую лигу открыт' },
    { tag: 'ЭФИР', text: 'tiktok.com/@ya_znayu02' },
    { tag: '499', text: 'голов за один игровой день' },
  ],
  kz: [
    { tag: 'FIFA OPEN', text: 'Босния — облыс чемпионы' },
    { tag: 'CS2 OPEN', text: 'күзгі маусым — жақында' },
    { tag: 'ЛИГА', text: 'студенттік лигаға жинақ ашық' },
    { tag: 'ЭФИР', text: 'tiktok.com/@ya_znayu02' },
    { tag: '499', text: 'бір ойын күнінде гол' },
  ],
};

// Единый этап турнира. Исторически status и regOpen редактировались независимо,
// поэтому открытая регистрация могла одновременно отображаться как «Анонс».
export const registrationPending = (tour = {}, now = Date.now()) => (
  tour.regOpen === true && tour.registrationClosed !== true
  && !['done', 'live'].includes(tour.status)
  && !!tour.registrationOpensAt && Date.parse(tour.registrationOpensAt) > now
);

export const KZ_MONTHS = ['қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым', 'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан'];

export const registrationOpensLabel = (tour, lang = 'ru') => {
  const time = Date.parse(tour.registrationOpensAt);
  if (!Number.isFinite(time)) return '';
  // Some browser ICU builds lack Kazakh month names and return "M10".
  if (lang === 'kz') {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Almaty', day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    }).formatToParts(time).map(part => [part.type, part.value]));
    return `Тіркелу: ${parts.day} ${KZ_MONTHS[Number(parts.month) - 1]} ${parts.hour}:${parts.minute} (UTC+5)`;
  }
  const formatted = new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Asia/Almaty', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).format(time);
  return `Регистрация: ${formatted} (UTC+5)`;
};

export const tournamentPhase = (tour = {}, now = Date.now()) => {
  if (tour.status === 'done' || tour.status === 'live') return tour.status;
  if (tour.registrationClosed === true) return 'closed';
  if (tour.registrationOpensAt && (!Number.isFinite(Date.parse(tour.registrationOpensAt)) || now < Date.parse(tour.registrationOpensAt))) return 'soon';
  if (tour.regOpen === true && tour.registrationClosed !== true) return 'registration';
  return 'soon';
};

export const teamRegistrationOpen = (tour = {}, now = Date.now()) => tournamentPhase(tour, now) === 'registration';

export const hasEntryFee = (tour = {}) => tour.entryFee != null
  ? Number(tour.entryFee) > 0
  : !!(tour.fee_ru || tour.fee_kz || tour.teamGame === 'cs2');

export const sortTournaments = (tours) => [...tours].sort((a, b) => {
  if ((a.status === 'done') !== (b.status === 'done')) return a.status === 'done' ? 1 : -1;
  return (b.featuredPriority || 0) - (a.featuredPriority || 0);
});

export const ST_COLOR = {
  done: 'var(--fed-fg-muted)',
  live: 'var(--fed-ok)',
  soon: 'var(--fed-gold)',
  registration: 'var(--fed-ok)',
  closed: 'var(--fed-accent-bright)',
};
export const ST_BG = {
  done: 'var(--fed-surface-2)',
  live: 'rgba(67,217,106,.12)',
  soon: 'rgba(230,183,60,.12)',
  registration: 'rgba(67,217,106,.12)',
  closed: 'rgba(225,18,23,.12)',
};
